import { parse } from 'date-fns';
import i18n from 'i18next';
import { API_DATE_FORMAT, format } from '../../../../utils';
export function getSelectedFlightsInfo(flights = []) {
    if (!flights.length) {
        return '';
    }
    return flights
        .map(flight => {
        var _a, _b;
        if (!((_b = (_a = flight === null || flight === void 0 ? void 0 : flight.flightInfo) === null || _a === void 0 ? void 0 : _a.segments) === null || _b === void 0 ? void 0 : _b.length)) {
            return '';
        }
        return flight.flightInfo.segments
            .map(segment => {
            var _a, _b;
            const flightDate = format(parse(segment.segment.departure.date, API_DATE_FORMAT, new Date()), 'dd.MM.yyyy');
            return i18n.t('Exchange:{{segmentId}}. {{depDate}}, {{airlineCode}}{{flightNumber}}. {{depIata}}({{depTime}}) -> {{arrIata}}({{arrTime}}). Тариф {{tariff}}', {
                segmentId: parseInt(segment.segment.id, 10) + 1,
                depDate: flightDate,
                airlineCode: segment.segment.marketingAirline.iata,
                flightNumber: segment.segment.flightNumber,
                depIata: (_b = (_a = segment.segment.departure) === null || _a === void 0 ? void 0 : _a.airport) === null || _b === void 0 ? void 0 : _b.iata,
                depTime: segment.segment.departure.time,
                arrIata: segment.segment.arrival.airport.iata,
                arrTime: segment.segment.arrival.time,
                tariff: flight.fareName
            });
        })
            .join('\n');
    })
        .filter(Boolean)
        .join('\n');
}
